import { useQuery } from "@tanstack/react-query";
import React from "react";
import ProjectImg from "./ProjectImg";

const Portfolio = () => {
  const { data: portfolioImage = [], isLoading } = useQuery({
    queryKey: ["projectImages"],
    queryFn: async () => {
      const res = await fetch(
        "https://portfolio-server-smoky.vercel.app/projectss"
      );
      const data = await res.json();
      return data;
    },
  });

  return (
    <div className="container m-auto text-center mt-36" id="portfolio">
      <h1
        className="text-8xl text-center font-bold text-white"
        style={{ fontSize: "6rem" }}
      >
        MY PROJECTS {portfolioImage.length}
      </h1>
      <div className="grid grid-cols-1 lg:grid-cols-3">
        {portfolioImage.map((project) => (
          <ProjectImg key={project.id} project={project}></ProjectImg>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
